<!-- PageBack -->

<template>
  <van-icon name="play-circle-o" class="bage-back" @click="go_back"/>
</template>

<style scoped>
.bage-back {
  transform: rotate(180deg);
  position: fixed;
  top: 5px;
  left: 5px;
  z-index: 99999;
  font-size: 30px;
  color: #6d6d6d;
  font-weight: 900;
  text-shadow: 5px 2px 10px #d7d8e0;
}
</style>

<script>
export default {
  methods: {
    go_back() {
      history.back()
    }
  }
}
</script>